<template>
  <layout>
    <!--总统计区-->
    <template v-slot:pageTab>
      <div class="headerA flex-center">
        <div class="flex-center-col">
          <font class="fontColor">操作日志</font>
        </div>
      </div>
      <div class="headerB flex-between">
        <div class="flex-center-y">
          <dl class="item" @click="tab('0')" v-if="!actionFrom || actionFrom == 0">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">
                <p>登录<br />日志</p>
              </div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.action_0 || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">次</div>
            </dt>
          </dl>
          <dl class="item" @click="tab('100')" v-if="!actionFrom || actionFrom == 100">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">
                <p>接收<br />审核</p>
              </div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.action_100 || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">次</div>
            </dt>
          </dl>
          <dl class="item" @click="tab('200')" v-if="!actionFrom || actionFrom == 200">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">
                <p>排放<br />审核</p>
              </div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.action_200 || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">次</div>
            </dt>
          </dl>
          <dl class="item" @click="tab('300')" v-if="!actionFrom || actionFrom == 300">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">
                <p>运输<br />审核</p>
              </div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.action_300 || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">次</div>
            </dt>
          </dl>
          <dl class="item" @click="tab('500')" v-if="!actionFrom || actionFrom == 500">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">
                <p>船舶<br />审核</p>
              </div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.action_500 || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">次</div>
            </dt>
          </dl>
        </div>
      </div>
    </template>
    <!--总统计区 end-->

    <!--搜索及功能区-->
    <template v-slot:pageSearch>
      <ul class="tab">
        <li v-if="!actionFrom">
          <Select class="QHSelectClass" v-model="searchMap.action" style="width: 250px" @on-change="search()">
            <span slot="prefix" class="prefixBox">操作类型</span>
            <Option value="0">登录数据大屏</Option>
            <Option value="100">接收单位审核</Option>
            <Option value="200">排放单位审核</Option>
            <Option value="300">运输单位审核</Option>
            <Option value="400">运输车辆审核</Option>
            <Option value="500">审核运输船舶</Option>
          </Select>
        </li>
        <li style="width: 280px">
          <QHdatePicker fmt="yyyy-MM-dd HH:mm" dayjs="YYYY-MM-DD HH:mm" split-panels v-model="searchMap.daterange" type="datetimerange" placeholder="操作时间"></QHdatePicker>
        </li>
        <li style="width: 240px">
          <Input size="small" v-model="searchMap.keyword" placeholder="请输入操作内容">
            <Select v-model="searchMap.keywordType" slot="prepend" style="width: 90px">
              <Option value="orgName">行政单位</Option>
              <Option value="username">操作账号</Option>
              <Option value="content">操作内容</Option>
            </Select>
          </Input>
        </li>
        <li>
          <Button type="warning" size="small" @click="search">查询</Button>
        </li>
        <li>
          <Button type="primary" @click="uploadExcel" size="small">导出</Button>
        </li>
      </ul>
    </template>
    <!--搜索及功能区 end-->

    <!--主体呈现区-->
    <template v-slot:pageContent>
      <QHTable :total="total['pageCount'] || 0" :pageThis="pageThis">
        <Table :columns="columns" :data="list" @on-selection-change="(event) => $tableSeletChange(event, pageThis)" :loading="loading" class="QHTableList">
          <!--分割区-->
          <template slot-scope="{ row }" slot="name">
            <span class="hotFont5"> {{ row.name }}</span>
          </template>
          <template slot-scope="{ row }" slot="username">
            <span class="hotFont4"> {{ row.username }}</span>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="content"> {{ row.content }}</template>
          <template slot-scope="{ row }" slot="addressFull"> {{ row.addressFull }}</template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="created">
            <span class="oe1">{{ $timeFmt(row.created, "YYYY-MM-DD HH:mm:ss") }}</span>
          </template>

          <!--分割区(清运状态)-->
          <template slot-scope="{ row }" slot="level">
            <Tag color="primary" v-if="row.level == 1">省级</Tag>
            <Tag color="primary" v-if="row.level == 2">市级</Tag>
            <Tag color="primary" v-if="row.level == 3">区级</Tag>
            <Tag color="primary" v-if="row.level == 4">街道</Tag>
          </template>
        </Table>
      </QHTable>
    </template>
    <!--主体呈现区 end-->
    <!--弹窗组件区-->

    <template v-slot:pageBlock>
      <QHexcelDownload ref="QHexcelDownload"></QHexcelDownload>
    </template>
    <!--弹窗组件区 end-->
  </layout>
</template>
<script>
import QHexcelDownload from "@/layout/component/QHexcelDownload/QHexcelDownload";
export default {
  components: {
    QHexcelDownload,
  },

  data() {
    return {
      //列表配置项(loading加载效果,columns列,list数据,selectedRows选中,total统计项)@@@@@@@@@@@
      list: [],
      loading: false,
      pageThis: this,
      selectedRows: [],
      total: {},
      columns: this.$colFilter([
        {
          type: "selection",
          width: 40,
          align: "center",
        },
        {
          title: "账号等级",
          width: 80,
          align: "center",
          slot: "level",
        },
        {
          title: "行政单位",
          key: "name",
          width: 200,
          slot: "name",
        },
        {
          title: "操作账号",
          key: "username",
          width: 200,
          slot: "username",
        },
        {
          title: "登录端口",
          key: "app",
          width: 120,
          align: "center",
        },
        {
          title: "操作内容",
          key: "content",
          minWidth: 200,
          ellipsis: true,
          tooltip: true,
          resizable: true,
        },
        {
          title: "管辖范围",
          key: "addressFull",
          width: 200,
          slot: "addressFull",
        },
        {
          title: "操作IP",
          key: "ip",
          width: 130,
          align: "center",
        },
        {
          title: "操作时间",
          key: "created",
          width: 160,
          align: "center",
          slot: "created",
        },
      ]),

      //搜索配置项(searchMap触发才生效,searchMap改变就生效)@@@@@@@@@@@@@@@@@@@@@@@,
      searchMap: {
        keywordType: "content",
        action: 0,
        keyword: "",
        status: 100,
        pageNo: 1,
        pageSize: 25,
      },
      actionFrom: "",
    };
  },

  // +----------------------------------------------------------------------
  // | mounted
  // +----------------------------------------------------------------------
  mounted() {
    var action = this.$getUrlParams("action");
    if (action > -1) {
      this.actionFrom = action;
      this.searchMap.action = this.actionFrom || 0;
    }
    this.getList();
  },

  methods: {
    // +----------------------------------------------------------------------
    // | 导出excel
    // +----------------------------------------------------------------------
    uploadExcel() {
      var that = this;
      var title = "红白蓝平台操作日志";
      this.searchMap = this.$trimObjectSpaces(this.searchMap);
      var searchMap = this.$copyObj(this.searchMap);
      searchMap["ids"] = this.$copyObj(this.selectedRows);
      this.$refs.QHexcelDownload.hiPop({
        title: title,
        api: that.$api.getLogExcelList,
        searchMap: searchMap,
        columns: this.$ExcelDownloadConfig["headLog"],
      });
    },

    // +----------------------------------------------------------------------
    // | 列表
    // +----------------------------------------------------------------------
    getList() {
      var that = this;
      this.searchMap = this.$trimObjectSpaces(this.searchMap);
      var parameter = this.searchMap;
      var https = {
        api: this.$api.getLogList,
        parameter: parameter,
      };
      this.$httpsApi(https, function (res) {
        that.total = res.count;
        that.dataLoading = true;
      });
    },

    // +----------------------------------------------------------------------
    // | 搜索
    // +----------------------------------------------------------------------
    search() {
      this.getList();
    },

    // +----------------------------------------------------------------------
    // | 切换
    // +----------------------------------------------------------------------
    tab(action) {
      this.searchMap.action = action;
      this.getList();
    },
  },
};
</script>

<style>
.pageContent {
  left: -10px;
  min-width: 100%;
}
.pageSearch {
  left: 0px;
  min-width: 100%;
}
.QHPage {
  left: 5px;
}
</style>
